import React from 'react';
import styles from './PageStyles.module.css';
import { FaTelegramPlane } from 'react-icons/fa';
import { motion } from 'framer-motion';

const pageContentVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (custom = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.5, ease: "easeOut", delay: custom * 0.15 }
    }),
};

const pageContainerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: {duration: 0.3} }
}

const TeamPage = () => {
    const telegramLink = "https://t.me/zhai_kazakh";

    return (
        <motion.div
            className={styles.pageContainer}
            variants={pageContainerVariants}
            initial="hidden"
            animate="visible"
        >
            <motion.h1 className={styles.pageTitle} variants={pageContentVariants} custom={0}>
                Присоединяйся к YEP<span className={styles.ampersandAccent}>&</span>TEAM!
            </motion.h1>

            <motion.section className={styles.textBlock} variants={pageContentVariants} custom={1}>
                <p>
                    Yep — это не просто набор сервисов, это динамично развивающаяся экосистема, нацеленная на создание новых возможностей и покорение цифровых горизонтов. Мы верим в силу сотрудничества и инноваций, и всегда открыты для талантливых, амбициозных и увлеченных людей, готовых расти вместе с нами.
                </p>
                <p>
                    Если ты разделяешь нашу страсть к созданию передовых продуктов, стремишься к постоянному развитию и хочешь стать частью команды, которая меняет правила игры в своих сферах — мы ищем именно тебя!
                </p>
            </motion.section>

            <motion.section className={styles.textBlock} variants={pageContentVariants} custom={2}>
                <h2 className={styles.subTitle}>Что мы предлагаем?</h2>
                <ul className={styles.list}>
                    <li>Возможность работать над интересными и разнообразными проектами в рамках экосистемы Yep (Link, Sell, Boost, Set, Coding и Future).</li>
                    <li>Пространство для реализации твоих идей и профессионального роста.</li>
                    <li>Дружную команду единомышленников и открытую корпоративную культуру.</li>
                    <li>Шанс внести свой вклад в продукты, которыми будут пользоваться тысячи людей.</li>
                </ul>
            </motion.section>

            <motion.section className={styles.textBlock} variants={pageContentVariants} custom={3}>
                <h2 className={styles.subTitle}>Кого мы ищем?</h2>
                <p>
                    Мы заинтересованы в специалистах разного профиля: от разработчиков и дизайнеров до маркетологов и менеджеров проектов. Главное — твое желание создавать, развиваться и достигать результатов.
                </p>
                <p>
                    Если ты готов принять вызов и покорять новые вершины вместе с Yep, мы будем рады познакомиться!
                </p>
            </motion.section>

            <motion.div className={styles.ctaContainer} variants={pageContentVariants} custom={4}>
                <a
                    href={telegramLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${styles.buttonMonochrome}`}
                >
                    <FaTelegramPlane className={styles.buttonIcon} />
                    Связаться с нами в Telegram
                </a>
            </motion.div>
        </motion.div>
    );
};

export default TeamPage;